module.exports = __webpack_public_path__ + "static/media/makeover.02598abd.jpg";